import React from 'react';
import ReactDOM from 'react-dom/client';
import { BlogSearchPage } from './BlogSearchPage';
import { BlogDataProps } from './IBlogSearchPage';
import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: BlogDataProps[];
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <BlogSearchPage data={data} />
  </React.StrictMode>
);
